module.exports = __webpack_public_path__ + "img/1 (58).c06284bf.png";